import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import type { ApplyCloseTemplateEntitySelectionRow } from "../applyCloseTemplateEntitySelection.types";
import { ApplyCloseEntityDateCell } from "./ApplyCloseEntityDateCell";

export const ApplyCloseEntityWorkStartDateCell = memo(
    function ApplyCloseEntityWorkStartDateCell({
        row,
    }: CellContext<
        ViewTableFeatures,
        ApplyCloseTemplateEntitySelectionRow,
        string
    >) {
        return (
            <ApplyCloseEntityDateCell
                row={row}
                field="workStartDate"
                addText="Add work start"
                placeholder="Work start..."
            />
        );
    },
);
